import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5c1b71ed&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=5c1b71ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b71ed",
  null
  
)

export default component.exports